import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./UpButton.css";

const UpButton = ({ activeTab, isWhatsAppOpen }) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (activeTab !== "home" && activeTab !== "about us") return null;

  return (
    showButton && (
      <button
        className="up-button"
        onClick={scrollToTop}
        style={{
          bottom: isWhatsAppOpen ? "320px" : "80px", 
        }}
      >
        <FaArrowUp />
      </button>
    )
  );
};

export default UpButton;